<template>
  <div>
    <v-overlay :value="!dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
          </v-card>
           <p></p>
            <v-alert
              class="text-left"
              dense
              outlined
              type="error"
            >
              โปรดกรอกข้อมูลให้ถูกต้อง
            </v-alert>
          <v-card>
            <v-card
            class="mx-auto my-2 text-left"
            elevation="12"
            v-for="(items, index) in dataItem" :key="index"
          >
            <v-card-title>
              <v-row>
                <v-col cols="12">
                <b>รายการตรวจ Covid-19</b>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <div class="text--primary" @click="getDataById(items)">
                <v-row>
                <v-col cols="6">
                วิธีการตรวจ:  <br> <b><h5>{{items.covidCheckName}}</h5></b>
                </v-col>
                 <v-col cols="6" >
                จุดตรวจมาจากแหล่งใด: <br> <b><h5>  {{items.covidSourceReceived}} </h5></b>
                 </v-col>
                <v-col cols="12" >
                สถานที่ตรวจ: <br> <b><h5>  {{items.covidCheckType}} </h5></b>
                 </v-col>
                 <v-col cols="12" v-if="items.covidCheckType ==='ตรวจที่โรงพยาบาล'">
                โรงพยาบาล: <br> <b><h5>  {{items.covidCheckHospital}} </h5></b>
                 </v-col>
                 <v-col cols="6">
                วันที่ตรวจ: <br> <b><h5> {{items.covidCheckDay}}/{{items.covidCheckMonth}}/{{items.covidCheckYear}}  </h5></b>
                 </v-col>
                 <v-col cols="6">
                ช่วงเวลา: <br> <b><h5>{{items.covidCheckTime}} </h5></b> <br>
                 </v-col>
                 </v-row>
              </div>
            </v-card-text>

          </v-card>
            <v-row :show="!dataReady">
              <v-col cols="12" sm="6" md="4">
              <v-btn color="success" dark block x-large @click="dialog = true"
                >กดเพิ่มประวัติตรวจ Covid-19<v-icon right dark>
                  mdi-plus-circle
                </v-icon></v-btn
              >
              </v-col>
            </v-row>
            <v-dialog v-model="dialogEdit" fullscreen persistent>

              <v-card>
                <v-toolbar
                color="indigo"
                dark
              >
                <v-toolbar-title>ประวัติตรวจ Covid-19</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="dialogEdit = false">
                  <v-icon >mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <br>
                <v-card-text>
                     <v-row no-gutters>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formUpdate.covidCheckName"
                          :items="vaccine"
                          label="(*)วิธีการตรวจ"
                           class="select"
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formUpdate.covidSourceReceived"
                          :items="covidSourceReceivedItem"
                          label="(*)จุดตรวจมาจากแหล่งใด"
                          class="select"
                          outlined
                        ></v-select>
                      </v-col>
                       <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formUpdate.covidCheckType"
                          :items="typeCheckCovidItem"

                          label="(*)สถานที่ตรวจ"
                          class="select"
                          outlined
                        ></v-select>
                        <!-- <v-text-field
                            v-model="formUpdate.covidCheckType"
                            label="อุปกรณ์ที่ใช้ในการตรวจ"
                             :rules="nameRules"
                            :error="false"
                            counter="100"
                             class="select"
                            maxlength="100"
                            outlined
                            required
                        ></v-text-field> -->
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="formUpdate.covidCheckType === 'ตรวจที่โรงพยาบาล'">
                        <v-text-field
                            v-model="formUpdate.covidCheckHospital"
                            :error="false"
                             :rules="nameRules"
                            counter="60"
                            maxlength="60"
                            label="สถานพยาบาล"
                            placeholder="โปรดระบุชื่อเต็ม"
                             class="select"
                            outlined
                            required
                        ></v-text-field>
                        </v-col>
                      <v-col cols="9" sm="9" md="9" >
                      <v-file-input
                        v-model="files"
                        @change="fileupload"
                        :placeholder="formUpdate.fileName || 'ไฟล์ผลตรวจ'"
                        outlined
                        required
                      ></v-file-input>
                      </v-col>
                       <v-spacer></v-spacer>
                       <v-col cols="3" sm="3" md="3" >
                    <v-btn
                        :href="formUpdate.covidCheckFile"
                         target="_blank"
                        download
                          x-large
                      >
                        <v-icon
                          dark
                        >
                          mdi-cloud-download
                        </v-icon>
                    </v-btn>
                      </v-col>
                       <v-col cols="6" sm="6" md="6">
                        <v-select
                        class="select"
                          v-model="formUpdate.covidCheckDay"
                          :items="dayName"
                          outlined
                          label="วัน"
                        ></v-select>
                      </v-col>
                        <v-col cols="6" sm="6" md="6">
                        <v-select
                        class="select"
                          v-model="formUpdate.covidCheckMonth"
                          :items="monthNameTH"
                          outlined
                          label="เดือน"
                        ></v-select>
                      </v-col>
                        <v-col cols="12" sm="6" md="4">
                        <v-select
                        class="select"
                          v-model="formUpdate.covidCheckYear"
                          :items="yearsNumber"
                          outlined
                          label="ปี"
                        ></v-select>
                      </v-col>
                       <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="this.formUpdate.hour"
                          :items="hourNumber"
                          label="ชั่วโมง"
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="this.formUpdate.minute"
                          :items="minuteNumber"
                          label="นาที"
                          outlined
                        ></v-select>
                      </v-col>
                    </v-row>
                  <small>*โปรดใส่ข้อมูลตามความจริง</small>
                </v-card-text>
                <v-card-actions>
                   <v-btn color="red darken-1" text @click="dialogEdit = false, deleteData(formUpdate)" >
                    delete
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialogEdit = false">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="edit(formUpdate)" >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog" fullscreen persistent>

              <v-card>
                <v-toolbar
                color="indigo"
                dark
              >
                <v-toolbar-title>เพิ่มประวัติตรวจ Covid-19</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="dialog = false">
                  <v-icon >mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <br>
                <v-card-text>
                     <v-row no-gutters>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="covidCheckName"
                          :items="vaccine"
                          label="วิธีการตรวจ"
                          class="select"
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="covidSourceReceived"
                          :items="covidSourceReceivedItem"
                          label="จุดตรวจมาจากแหล่งใด"
                          class="select"
                          outlined
                        ></v-select>
                      </v-col>
                      <!-- typeCheckCovidItem -->
                       <v-col cols="12" sm="12" md="12">
                          <v-select
                          v-model="covidCheckType"
                          :items="typeCheckCovidItem"
                          label="สถานที่ตรวจ"
                          class="select"
                          outlined
                        ></v-select>
                        <!-- <v-text-field
                            v-model="covidCheckType"
                            label="อุปกรณ์ที่ใช้ในการตรวจ"
                            outlined
                             :rules="nameRules"
                            :error="false"
                            counter="100"
                            maxlength="100"
                            required
                        ></v-text-field> -->
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="covidCheckType == 'ตรวจที่โรงพยาบาล'">
                        <v-text-field
                            v-model="covidCheckHospital"
                            label="สถานพยาบาล"
                            outlined
                             :rules="nameRules"
                            :error="false"
                            counter="100"
                            maxlength="100"
                            required
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" >
                      <v-file-input
                        v-model="files"
                        @change="fileupload"
                         label="แนบไฟล์ผลตรวจ"
                        placeholder="แนบไฟล์ผลตรวจ"
                        outlined
                        required
                      ></v-file-input>
                      </v-col>
                        <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="day"
                          :items="dayName"
                          label="วัน"
                          class="select"
                         outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="month"
                          :items="monthNameTH"
                          label="เดือน"
                          class="select"
                         outlined
                        ></v-select>
                      </v-col>
                       <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="year"
                          :items="yearsNumber"
                          label="ปี"
                          class="select"
                         outlined
                        ></v-select>
                      </v-col>
                       <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="hour"
                          :items="hourNumber"
                          label="ชั่วโมง"
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="minute"
                          :items="minuteNumber"
                          label="นาที"
                          outlined
                        ></v-select>
                      </v-col>
                    </v-row>
                  <small>*โปรดใส่ข้อมูลตามความจริง</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="approve()" >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import dayName from '../../assets/master/Date/day.json'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import moment from 'moment'
import hourNumber from '../../assets/master/Date/Hour.json'
import minuteNumber from '../../assets/master/Date/Minute.json'
import vaccine from '../../assets/master/vaccine/typeCheckCovid.json'
import categoryName from '../../assets/master/vaccine/categoryName.json'
import covidSourceReceivedItem from '../../assets/master/vaccine/covidSourceReceived.json'
import typeCheckCovid2 from '../../assets/master/vaccine/typeCheckCovid2.json'
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'VaccinHistory',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      imageUrlBack: '',
      imageHeadHRM: '',
      dataItem: [],
      dialog: false,
      dialogEdit: false,
      formUpdate: {
        covidCheckNameName: '',
        covidCheckNameYear: '',
        covidCheckNameMonth: '',
        covidCheckNameDay: '',
        covidCheckNameTime: '',
        hour: '',
        minute: '',
        covidCheckNameCategory: '',
        covidCheckHospital: '',
        covidCheckType: 'ตรวจด้วยตัวเอง(ATK)',
        fileName: '',
        covidCheckFile: '',
        covidSourceReceived: ''
      },
      covidCheckNameCategory: '',
      covidCheckName: 'Swap',
      covidCheckHospital: '',
      covidCheckType: 'ตรวจด้วยตัวเอง(ATK)',
      year: '',
      month: '',
      day: '',
      hour: 8,
      minute: 30,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      hourNumber: hourNumber,
      minuteNumber: minuteNumber,
      vaccine: vaccine,
      categoryName: categoryName,
      covidSourceReceivedItem: covidSourceReceivedItem,
      typeCheckCovidItem: typeCheckCovid2,
      nameRules: [(v) => !!v || 'Input is required'],
      files: null,
      covidCheckFile: '',
      fileName: '',
      covidSourceReceived: 'บริษัทฯจัดหา'
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.vaccineAdd = require('@/assets/Icon/vaccineAdd.png')
    this.vaccineAddComplete = require('@/assets/Icon/วัคซีนเข็มที่8.png')

    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    this.month = this.getMonthTh()
    // if (JSON.parse(localStorage.getItem('liff_info'))) {
    // await this.Home()
    // } else {
    await this.getData()
    // }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      this.dataReady = false
      this.dataItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/covid_check/get?empCode=' +
            JSON.parse(localStorage.getItem('liff_info')).empCode
        )
        .then(async (response) => {
          this.dataItem = response.data
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataItem = []
          this.dataReady = true
        })
    },
    async getDataById (ds) {
      this.dialogEdit = true
      this.formUpdate = []
      this.formUpdate.fileName = 'ผลตรวจ'
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_check/getID?covidCheckId=" + ds.covidCheckId
        )
        .then(async (response) => {
          // console.log('getDataById', response.data)
          const vc = response.data.covidCheckTime.split(':')

          this.formUpdate = response.data
          this.formUpdate.covidCheckMonth = this.getMonthINTToTH(this.formUpdate.covidCheckMonth)
          this.formUpdate.hour = Number(vc[0])
          this.formUpdate.minute = Number(vc[1])

          if (response.data.covidCheckFile !== null) {
            const fileNameSplit = response.data.covidCheckFile.split('covid_check/')
            // console.log(fileNameSplit[1])
            this.formUpdate.fileName = fileNameSplit[1]
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async edit (ds) {
      // console.log(ds)

      let dt = {
        covidCheckName: this.formUpdate.covidCheckName,
        covidCheckHospital: this.formUpdate.covidCheckHospital,
        covidCheckType: this.formUpdate.covidCheckType,
        covidCheckYear: this.formUpdate.covidCheckYear,
        covidCheckMonth: this.getMonthThToINT(this.formUpdate.covidCheckMonth),
        covidCheckDay: this.formUpdate.day,
        covidCheckTime: this.formUpdate.hour + ':' + this.formUpdate.minute,
        covidCheckFile: this.covidCheckFile
      }
      // console.log(ds)
      let check = true
      if (dt.covidCheckType === 'ตรวจที่โรงพยาบาล' && dt.covidCheckHospital === '') {
        check = false
        // alert('โปรดระบุชื่อโรงพยาบาล')
        this.$swal('', 'โปรดระบุชื่อโรงพยาบาล', 'warning')
      } else {
        check = true
      }

      if (check) {
        await axios
          .post(
          // eslint-disable-next-line quotes
            this.DNS_IP + "/covid_check/edit/" + ds.covidCheckId,
            dt
          )
          .then(async (response) => {
            // console.log(response)
            this.dialogEdit = false
            this.getData()
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dialogEdit = false
          })
      }
    },
    async deleteData (item) {
      // console.log(item)
      let dt = {
        LAST_USER: JSON.parse(localStorage.getItem('liff_info')).userName
      }
      console.log(dt)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_check/delete/" + item.covidCheckId,
          dt
        )
        .then(async (response) => {
          console.log(response)
          this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function deleteData : ', error)
        })
    },
    async approve () {
      this.dialog = false
      // console.log(this.profile)
      // console.log(this.minute)
      let ds = {
        empCode: JSON.parse(localStorage.getItem('liff_info')).empCode,
        covidCheckName: this.covidCheckName,
        covidCheckHospital: this.covidCheckHospital,
        covidCheckType: this.covidCheckType,
        covidSourceReceived: this.covidSourceReceived,
        covidCheckYear: this.year,
        covidCheckMonth: this.getMonthThToINT(this.month),
        covidCheckDay: this.day,
        covidCheckTime: this.hour + ':' + this.minute,
        covidCheckFile: this.covidCheckFile
      }
      console.log(ds)
      await axios
        .post(
        // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_check/add", ds
        )
        .then(async (response) => {
          this.dialog = false
          // console.log(response)
          this.getData()
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dialog = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      // console.log('params', params)
      await axios
        .post(this.DNS_IP + '/covid_check/upload', params)
        .then(function (response) {
          _this.covidCheckFile = _this.DNS_IP + '/' + response.data
          console.log(_this.covidCheckFile)
        }).catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
.select {
      /* max-width: 60px;
      max-height: 60px; */
      font-size: 14px;
}
.margin {
      margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/CovidCheckHistory.vue